import React from 'react';
import { getPartnerTheme } from '../config/partnerThemes';

// The "powered by FHO" mark shown beside the menu button on every coach page,
// bundled or broken out. A theme can opt out with poweredByFHO: false.
// Pass `light` on pages whose header has a light background.
const PoweredByFHO = ({ light = false }) => {
  const theme = getPartnerTheme();
  if (theme.poweredByFHO === false) return null;
  const c = light
    ? { label: 'rgba(38,70,83,0.75)', f: '#4f46e5', h: '#ef4444', o: '#059669' }
    : { label: 'rgba(255,255,255,0.65)', f: '#8b93f0', h: '#f87171', o: '#34d399' };
  return (
    <div style={{ textAlign: 'right', lineHeight: 1.15, flexShrink: 0 }}>
      <span style={{ display: 'block', fontSize: '9px', color: c.label, letterSpacing: '0.5px' }}>powered by</span>
      <span style={{ fontSize: '16px', fontWeight: 900, letterSpacing: '0.5px' }}>
        <span style={{ color: c.f }}>F</span><span style={{ color: c.h }}>H</span><span style={{ color: c.o }}>O</span>
      </span>
    </div>
  );
};

export default PoweredByFHO;
